/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SubIndustry
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * Returns list of unique sub-industries.
 * @summary Sub Industries
 */
export const subIndustries = (

 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<SubIndustry[]>(
      {url: `/securities/classification/sub-industries`, method: 'GET', signal
    },
      options);
    }




export const getSubIndustriesQueryKey = () => {
    return [
    `/securities/classification/sub-industries`
    ] as const;
    }


export const getSubIndustriesQueryOptions = <TData = Awaited<ReturnType<typeof subIndustries>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof subIndustries>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSubIndustriesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof subIndustries>>> = ({ signal }) => subIndustries(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof subIndustries>>, TError, TData> & { queryKey: QueryKey }
}

export type SubIndustriesQueryResult = NonNullable<Awaited<ReturnType<typeof subIndustries>>>
export type SubIndustriesQueryError = unknown


/**
 * @summary Sub Industries
 */

export function useSubIndustries<TData = Awaited<ReturnType<typeof subIndustries>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof subIndustries>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSubIndustriesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






